import { Ban, AlertTriangle, Info } from 'lucide-react';
import { useShallow } from 'zustand/react/shallow';
import { useStore } from '@/store';
import { selectWarnings } from '@/store/selectors';
import { CollapsibleSection } from '@/components/ui/CollapsibleSection';
import { Button } from '@/components/ui/Button';
import { WarningSeverity as WS } from '@bioavail/shared-types';

/** Lists warnings sorted by severity (collapsible section 4, P1.6.4). */
export function ValidationPanel() {
  const warnings = useStore(useShallow(selectWarnings));
  const dismiss = useStore((s) => s.dismissWarning);

  if (warnings.length === 0) return null;

  return (
    <CollapsibleSection sectionKey="calculator.validation" title="Validation & Warnings" column="right">
      {warnings.map((w, i) => (
        <div key={`${w.code}-${i}`} className={`warning-item ${w.severity}`}>
          <div className="warning-message">
            {w.severity === WS.Block ? (
              <Ban size={14} aria-hidden="true" />
            ) : w.severity === WS.Warn ? (
              <AlertTriangle size={14} aria-hidden="true" />
            ) : (
              <Info size={14} aria-hidden="true" />
            )}{' '}
            {w.message}
          </div>
          <div className="warning-remediation">{w.remediation}</div>
          {w.severity !== WS.Block ? (
            <Button size="sm" variant="ghost" onClick={() => dismiss(w.code)}>
              Dismiss
            </Button>
          ) : null}
        </div>
      ))}
    </CollapsibleSection>
  );
}
